import { cn } from "@/lib";

const ArtifactLogo = ({ className = "", size = 24, ...props }) => {
  return (
    <svg
      className={cn(className)}
      fill="url(#purple-gradient)"
      size={size}
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="10417.000000pt"
      height="10417.000000pt"
      viewBox="0 0 10417.000000 10417.000000"
      preserveAspectRatio="xMidYMid meet"
      {...props}
    >
      <g
        transform="translate(0.000000,10417.000000) scale(0.100000,-0.100000)"
        fill="#000000"
        stroke="none"
      >
        <path
          d="M47970 86173 c-947 -341 -2252 -979 -3407 -1665 l-253 -150 0 -742
c0 -704 -1 -743 -19 -781 -13 -28 -467 -488 -1480 -1500 l-1461 -1460 0 -3166
0 -3165 1089 -1082 c1160 -1152 1141 -1132 1141 -1226 -1 -147 -164 -250 -294
-186 -28 13 -405 384 -1173 1152 -883 883 -1137 1143 -1152 1178 -20 45 -21
55 -21 3333 0 2932 2 3292 15 3325 11 26 438 459 1480 1502 l1465 1465 -2 548
-3 549 -219 -142 c-626 -404 -1303 -881 -1895 -1334 l-221 -170 0 -498 c0
-338 -4 -514 -11 -546 -11 -44 -40 -76 -425 -462 l-414 -415 0 290 0 290 220
220 220 220 0 282 c0 156 -3 283 -6 283 -16 0 -687 -568 -1004 -850 -728 -649
-1539 -1451 -2192 -2168 -1614 -1771 -3049 -3795 -4203 -5927 -123 -227 -505
-995 -604 -1215 -713 -1574 -1205 -3102 -1525 -4735 -372 -1902 -475 -3879
-300 -5785 404 -4413 2124 -7903 5048 -10249 1182 -948 2516 -1693 4096 -2287
l245 -92 3 5654 2 5654 1969 0 c1346 0 1979 -3 1998 -10 16 -6 520 -501 1158
-1138 622 -620 1473 -1469 1892 -1886 l762 -760 53 18 c78 27 246 33 327 12
198 -51 349 -193 417 -396 29 -85 26 -252 -5 -348 -112 -341 -493 -497 -820
-336 -143 71 -269 234 -301 390 -16 77 -8 234 15 307 l19 58 -1840 1840 -1839
1839 -1832 0 -1833 0 0 -5474 0 -5475 173 -55 c812 -259 1632 -429 2402 -499
l140 -12 -3 294 -3 294 -750 755 c-540 542 -756 765 -770 795 -18 41 -19 139
-19 3876 l0 3835 21 43 c26 54 79 98 135 112 61 16 2783 15 2839 0 52 -15 119
-82 134 -134 8 -29 11 -764 11 -2631 l0 -2590 53 -22 c76 -32 173 -110 228
-183 99 -131 137 -294 106 -453 -26 -129 -67 -206 -162 -302 -57 -57 -99 -89
-147 -112 -172 -83 -371 -80 -541 10 -130 69 -244 216 -282 363 -19 75 -19
223 0 295 37 140 154 292 275 356 l55 29 0 2485 0 2485 -1157 3 -1158 2 0
-3647 0 -3648 751 -750 c417 -417 759 -766 770 -787 18 -35 19 -61 19 -416 l0
-379 53 -7 c68 -8 792 -8 983 0 l149 7 -3 654 c-1 447 1 668 9 696 9 38 430
462 4082 4116 2855 2856 4084 4079 4112 4092 136 64 290 -38 289 -191 -1 -30
-8 -68 -17 -85 -9 -16 -1827 -1841 -4041 -4055 l-4026 -4025 0 -584 0 -583 95
7 c53 4 106 10 118 13 12 4 2174 2161 4805 4793 l4782 4786 0 3551 0 3550
-837 842 c-461 463 -846 856 -855 873 -16 30 -17 132 -18 1449 l0 1417 -127
113 c-186 166 -358 309 -528 442 l-150 117 -3 -2358 -2 -2358 844 -845 c798
-799 844 -848 855 -892 8 -34 11 -569 11 -1936 l0 -1889 58 -22 c218 -84 412
-305 473 -538 28 -109 28 -279 -1 -388 -92 -356 -397 -595 -760 -596 -137 -1
-229 20 -356 81 -178 86 -325 249 -392 433 -76 210 -65 422 33 622 91 187 248
327 445 396 l75 27 3 1833 2 1834 -834 835 c-459 459 -842 851 -853 870 -17
34 -18 129 -21 2615 l-2 2581 -141 93 c-731 484 -1545 914 -2417 1277 -85 35
-158 64 -163 64 -5 0 -9 -199 -9 -463 l0 -462 866 -865 c593 -593 872 -878
885 -905 18 -39 19 -117 19 -2610 l0 -2570 411 -410 c231 -230 417 -424 425
-442 20 -45 17 -130 -5 -179 -43 -95 -170 -140 -266 -95 -27 13 -192 171 -502
482 -458 461 -461 464 -472 517 -8 38 -11 788 -11 2595 l0 2542 -860 860
c-665 666 -864 870 -879 905 -20 44 -21 64 -21 656 l0 610 -202 73 c-353 127
-1113 371 -1155 371 -11 0 -13 -199 -13 -1027 l0 -1028 1080 -1080 c761 -762
1084 -1091 1095 -1117 13 -33 15 -213 15 -1577 l0 -1539 53 -17 c130 -42 274
-144 363 -257 112 -144 166 -301 167 -488 1 -207 -67 -383 -207 -536 -375
-412 -1060 -307 -1296 197 -67 144 -90 350 -56 510 53 250 241 469 484 561
l82 31 0 1471 0 1471 -1076 1075 c-741 741 -1082 1087 -1095 1115 -18 38 -19
86 -19 1197 l0 1156 -152 37 c-84 20 -314 70 -510 110 l-358 73 0 -1696 0
-1695 980 -976 c538 -537 987 -992 997 -1011 17 -33 18 -112 21 -1455 1 -963
-1 -1436 -8 -1471 -33 -157 -226 -217 -343 -106 -67 63 -62 -57 -65 1472 l-2
1385 -980 980 c-691 692 -984 991 -995 1017 -13 33 -15 242 -15 1836 l0 1798
-142 27 c-79 16 -256 53 -394 83 -138 30 -254 54 -257 54 -4 0 -8 -633 -9
-1407 -3 -1297 -4 -1410 -20 -1438 -9 -16 -234 -247 -500 -512 -480 -478 -483
-481 -536 -492 -37 -8 -564 -11 -1777 -11 l-1725 0 0 210 0 210 1688 0 1687 0
383 383 382 382 0 1392 0 1392 -42 11 c-128 33 -436 130 -592 187 -742 268
-1287 619 -1668 1073 -467 555 -710 1375 -612 2057 18 126 57 267 173 633 840
2647 2208 5090 4012 7170 537 619 1230 1309 1723 1715 173 143 177 146 126
128z m-7660 -6038 l-130 -130 0 290 0 290 128 128 127 127 3 -287 2 -288 -130
-130z m101 -4420 c18 -38 19 -84 19 -1041 l0 -1000 -25 -50 c-15 -29 -65 -89
-125 -149 l-100 -100 0 1295 0 1295 106 -105 c58 -58 115 -123 125 -145z m39
-4210 l0 -205 -135 0 -135 0 0 205 0 205 135 0 135 0 0 -205z m1315 186 c49
-23 89 -64 109 -113 41 -98 -7 -212 -109 -259 -37 -17 -75 -19 -547 -19 l-508
0 0 205 0 205 508 0 c472 0 510 -2 547 -19z m-1325 -2251 l0 -210 -130 0 -130
0 0 210 0 210 130 0 130 0 0 -210z m0 -1725 l0 -205 -22 0 c-15 0 -58 -35
-130 -107 l-108 -108 0 291 0 291 48 21 c35 16 68 21 130 22 l82 0 0 -205z
m4885 179 c22 -11 53 -40 70 -63 24 -34 30 -54 33 -109 3 -79 -18 -125 -81
-176 l-39 -31 -2299 -3 -2299 -2 0 205 0 205 2288 -2 2287 -3 40 -21z m-4885
-2049 l0 -205 -130 0 -130 0 0 205 0 205 130 0 130 0 0 -205z m4787 195 c16
-6 933 -915 2143 -2125 l2115 -2115 1412 0 1412 0 33 63 c42 80 154 193 235
235 78 41 198 72 278 72 80 0 200 -31 278 -72 79 -41 192 -154 234 -233 50
-95 67 -167 67 -280 0 -113 -11 -159 -61 -263 -41 -87 -139 -192 -223 -239
-101 -57 -173 -76 -290 -76 -118 -1 -163 9 -269 60 -96 46 -202 149 -251 245
l-35 68 -1240 2 c-682 2 -1348 3 -1480 3 l-240 0 -46 27 c-29 17 -836 820
-2139 2128 l-2093 2100 -2179 0 -2178 0 0 205 0 205 2244 0 c1539 0 2254 -3
2273 -10z m-2419 -765 c49 -21 81 -52 103 -100 18 -38 19 -87 19 -962 l0 -923
1420 0 c1255 0 1425 -2 1458 -15 26 -11 493 -471 1617 -1594 l1580 -1579 1236
5 c1141 5 1240 4 1295 -12 58 -16 63 -21 562 -518 277 -276 515 -522 529 -546
75 -125 -8 -290 -154 -308 -101 -11 -94 -17 -608 497 l-470 470 -1260 0 -1261
0 -52 26 c-42 21 -346 321 -1614 1595 l-1561 1569 -2469 0 -2468 0 0 205 0
205 905 0 905 0 0 918 0 917 24 51 c23 49 59 84 107 103 37 15 116 13 157 -4z
m-2368 -2190 l0 -205 -130 0 -130 0 0 205 0 205 130 0 130 0 0 -205z m4880
-1188 c19 -11 904 -887 1965 -1948 l1930 -1929 820 0 820 1 33 57 c74 129 183
219 327 268 161 54 358 28 502 -66 157 -103 263 -299 263 -485 0 -202 -128
-419 -298 -508 -117 -61 -164 -72 -292 -71 -98 0 -125 4 -182 26 -153 58 -270
160 -334 295 l-35 73 -882 0 c-842 0 -884 1 -922 19 -28 13 -625 604 -1965
1945 l-1925 1926 -2110 0 -2110 0 -107 -107 -108 -108 2 289 3 289 26 19 c15
11 42 24 60 28 19 4 1035 7 2259 7 2144 -2 2226 -3 2260 -20z m-5010 -1012
l-130 -130 0 285 0 285 128 128 127 127 3 -282 2 -283 -130 -130z m6594 -4706
c146 -45 278 -160 346 -301 137 -281 22 -628 -255 -768 l-65 -33 0 -724 0
-723 28 -12 c120 -53 230 -157 288 -273 171 -348 -25 -750 -406 -831 -249 -53
-514 77 -631 308 -41 81 -59 159 -59 255 0 107 14 171 57 263 47 98 159 213
250 256 l62 29 0 727 1 727 -62 33 c-38 19 -93 62 -138 108 -121 120 -170 238
-170 405 0 158 54 295 159 403 156 159 383 217 595 151z"
        />
        <path
          d="M41279 82233 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"
        />
        <path
          d="M54060 67945 l0 -1140 650 -650 650 -650 0 981 0 981 -118 174 c-323
476 -708 956 -1060 1319 l-121 125 -1 -1140z"
        />
        <path
          d="M55770 63373 l0 -3403 539 0 539 0 6 33 c26 142 83 710 108 1067 17
249 17 1265 0 1495 -66 886 -178 1540 -387 2255 -178 609 -451 1286 -739 1830
l-66 125 0 -3402z"
        />
        <path
          d="M49758 64727 c-71 -30 -130 -76 -168 -132 -51 -74 -65 -121 -65 -220
0 -82 3 -97 33 -157 66 -135 186 -211 337 -211 149 -1 270 75 337 211 30 61
33 75 33 162 0 85 -3 101 -29 155 -38 76 -111 149 -184 183 -83 39 -213 43
-294 9z"
        />
        <path
          d="M55770 58604 c0 -853 -2 -949 -16 -980 -10 -21 -1914 -1931 -4645
-4661 -2546 -2545 -4627 -4628 -4625 -4630 7 -7 309 53 571 112 2186 496 4244
1638 5866 3255 294 293 455 465 687 735 888 1034 1599 2190 2130 3465 331 796
679 1905 883 2818 60 270 159 777 159 816 0 14 -49 16 -505 16 l-505 0 0 -946z"
        />
        <path
          d="M54200 59485 c-106 -33 -214 -142 -245 -249 -54 -180 30 -363 204
-449 59 -29 74 -32 151 -31 119 1 184 27 265 109 82 81 108 146 109 265 1 77
-2 92 -31 150 -34 70 -86 129 -144 166 -81 51 -214 68 -309 39z"
        />
        <path
          d="M67230 56699 c-187 -9 -493 -32 -677 -51 l-113 -11 0 -2640 c0 -1968
-3 -2650 -12 -2681 -10 -36 -179 -209 -1335 -1366 l-1323 -1325 0 -730 0 -730
2116 -2115 c1245 -1245 2124 -2131 2137 -2155 l22 -40 0 -4895 0 -4895 -27
-45 c-15 -25 -119 -137 -232 -250 l-206 -205 0 -648 0 -648 108 6 c554 32 958
76 1389 153 l153 27 2 7365 c3 7108 4 7366 21 7398 28 51 1273 1292 1313 1308
28 12 489 14 2968 14 l2934 0 12 38 c7 20 33 78 58 127 38 74 63 107 142 185
78 79 112 105 187 143 131 68 220 89 368 89 90 0 140 -5 199 -21 272 -72 480
-274 566 -546 30 -96 38 -262 17 -372 -31 -165 -93 -279 -222 -409 -101 -102
-188 -156 -320 -201 -73 -25 -93 -27 -240 -27 -154 -1 -163 0 -247 30 -228 82
-399 243 -489 463 l-33 81 -2866 0 -2865 0 -543 -543 -542 -542 0 -7243 c0
-5055 3 -7242 11 -7242 17 0 282 68 449 115 198 56 446 133 594 186 l116 41 0
6168 0 6168 -37 12 c-21 7 -78 33 -128 58 -74 38 -107 63 -185 142 -79 78
-105 112 -143 187 -68 132 -90 221 -90 368 -1 223 70 399 223 555 232 235 573
305 877 179 184 -77 351 -247 428 -437 57 -141 70 -348 30 -497 -63 -238 -241
-439 -470 -532 l-80 -32 -3 -6086 c-1 -4076 1 -6085 8 -6085 36 0 618 266 935
428 l210 107 5 4005 c5 3732 6 4007 22 4035 9 17 262 275 562 575 l546 545 0
1236 0 1235 -71 28 c-280 109 -467 342 -510 636 -59 406 220 801 623 884 386
79 774 -135 908 -501 148 -408 -53 -858 -455 -1014 l-70 -28 -3 -1028 -2
-1028 3792 3792 3791 3791 -145 169 c-264 305 -630 702 -817 888 l-91 90 -918
-917 c-504 -504 -931 -923 -949 -932 -29 -15 -401 -16 -4160 -16 l-4128 0
-1735 -1735 c-1237 -1236 -1746 -1739 -1772 -1750 -120 -49 -258 21 -288 146
-14 57 -7 99 25 154 13 22 822 837 1797 1811 1553 1551 1778 1772 1814 1782
31 9 1076 12 4160 12 l4119 0 870 871 870 870 -130 127 c-72 70 -229 218 -350
329 l-220 202 -755 -754 c-650 -648 -761 -755 -795 -764 -28 -8 -1083 -11
-3601 -11 l-3560 0 -51 25 c-33 17 -61 41 -79 68 -26 37 -29 51 -29 119 0 69
3 81 30 119 17 23 50 53 74 66 l44 23 3506 0 3506 0 693 693 694 694 -94 79
c-383 326 -888 718 -1315 1022 -207 147 -624 432 -632 432 -3 0 -411 -405
-906 -901 -617 -618 -913 -907 -940 -920 -39 -18 -110 -19 -2270 -19 -2142 0
-2232 1 -2270 19 -88 40 -129 110 -123 207 5 78 41 136 107 171 l44 23 2166 0
2166 0 829 829 829 829 -39 24 c-195 123 -581 352 -832 493 l-104 58 -526
-526 c-365 -365 -539 -532 -567 -544 -38 -17 -138 -18 -1990 -21 -1423 -2
-1965 1 -2005 9 -75 16 -142 80 -159 156 -23 94 24 192 113 241 29 16 176 17
1951 20 l1920 2 433 433 c237 237 432 435 432 439 0 8 -633 327 -728 368 l-53
23 -262 -261 c-215 -213 -269 -262 -302 -272 -29 -8 -486 -10 -1707 -8 l-1666
3 -44 30 c-123 87 -123 263 0 350 l44 30 1606 3 1607 2 152 152 c84 84 153
156 153 159 0 4 -111 55 -247 112 -1266 538 -2508 912 -3728 1122 -174 30
-526 85 -547 85 -5 0 -8 -1278 -8 -2840 0 -2532 -2 -2845 -15 -2878 -11 -26
-522 -544 -1780 -1802 l-1765 -1765 26 -70 c35 -92 43 -231 20 -329 -49 -210
-227 -388 -436 -437 -78 -18 -213 -16 -285 5 -193 56 -345 201 -406 388 -34
103 -34 252 0 357 96 291 407 463 701 387 l64 -17 921 921 920 920 -5 2111 -5
2112 -37 13 c-92 32 -202 100 -279 171 -263 248 -331 609 -174 928 79 163 196
279 360 360 131 65 195 80 355 80 114 0 147 -4 210 -23 281 -88 482 -294 557
-572 24 -89 24 -299 -1 -390 -63 -237 -250 -448 -479 -540 l-72 -29 -3 -1898
-2 -1898 595 595 595 595 0 2797 0 2796 -37 6 c-40 6 -317 29 -563 47 -192 13
-1178 20 -1400 8z"
        />
        <path
          d="M65910 56568 c-294 -50 -479 -83 -607 -109 l-153 -32 0 -1075 c0
-789 -3 -1086 -12 -1116 -10 -35 -105 -135 -690 -721 l-678 -680 0 -1810 0
-1810 1125 1125 1125 1125 0 2557 0 2558 -27 -1 c-16 -1 -53 -6 -83 -11z"
        />
        <path
          d="M64560 56284 c-257 -69 -581 -168 -834 -256 -127 -44 -252 -87 -278
-96 l-48 -16 0 -455 0 -456 63 -30 c92 -44 204 -159 250 -255 46 -99 61 -167
61 -270 -1 -255 -175 -481 -429 -556 -87 -26 -230 -24 -320 4 -422 130 -558
657 -250 968 45 45 94 82 137 105 l68 34 0 372 0 372 -62 -26 c-242 -98 -756
-338 -1000 -466 l-148 -78 0 -1975 0 -1974 28 -11 c93 -38 216 -105 269 -149
300 -245 379 -684 182 -1016 -70 -119 -236 -269 -354 -319 -103 -44 -161 -57
-291 -62 -168 -7 -250 10 -394 79 -93 45 -115 61 -200 147 -78 78 -105 113
-143 188 -68 132 -89 220 -90 368 0 142 17 222 73 340 96 200 233 321 483 423
l27 12 0 1860 0 1861 -31 -16 c-65 -34 -473 -284 -654 -401 -248 -160 -477
-318 -757 -522 l-228 -166 0 -3150 0 -3151 2053 -2055 c1801 -1802 2055 -2060
2065 -2096 9 -29 12 -198 12 -557 l0 -517 1008 -2 1007 -3 40 -22 c76 -40 115
-105 115 -188 0 -83 -39 -148 -115 -188 l-40 -22 -1007 -3 -1008 -3 0 -1040
c0 -734 -3 -1054 -11 -1087 -11 -45 -116 -152 -2351 -2387 l-2339 -2341 208
-204 c278 -273 438 -421 791 -729 l74 -64 1619 1619 c1078 1078 1618 1624
1615 1634 -3 8 -19 53 -35 100 -69 194 -25 422 111 574 62 70 148 129 236 163
89 34 247 43 342 19 111 -28 187 -72 271 -155 320 -320 182 -847 -256 -977
-68 -20 -228 -24 -286 -7 l-36 11 -1619 -1619 c-891 -891 -1620 -1623 -1622
-1628 -10 -29 778 -600 1147 -830 l84 -53 2068 2068 2069 2069 -1 1400 0 1400
-61 29 c-125 59 -245 204 -290 351 -28 90 -30 233 -4 320 88 296 378 478 671
421 278 -54 475 -290 475 -569 0 -173 -51 -299 -170 -417 -51 -51 -95 -84
-137 -104 l-63 -30 0 -1455 c0 -1006 -3 -1468 -11 -1496 -9 -35 -277 -307
-2095 -2125 l-2084 -2085 168 -93 c335 -187 838 -429 1188 -572 l141 -58 769
769 768 768 -23 68 c-18 49 -25 98 -29 176 -4 95 -1 117 22 190 145 468 755
565 1036 164 163 -230 136 -541 -63 -741 -153 -153 -365 -212 -562 -156 l-70
19 -708 -707 -707 -707 147 -48 c413 -133 916 -255 1368 -331 460 -78 1089
-136 1463 -136 l122 0 0 715 c0 624 2 720 16 753 9 24 93 115 230 252 l214
216 0 4759 0 4760 -2116 2115 c-1475 1474 -2122 2127 -2135 2155 -18 39 -19
126 -19 3008 0 2650 2 2972 15 3005 11 26 220 242 690 712 l675 675 -2 966 -3
966 -165 -43z"
        />
        <path
          d="M67729 54777 c-67 -19 -131 -60 -182 -117 -62 -69 -90 -143 -90 -245
-1 -70 3 -89 30 -146 39 -85 88 -138 160 -177 220 -116 477 -3 539 238 56 221
-107 442 -337 456 -44 2 -93 -1 -120 -9z"
        />
        <path
          d="M59135 53405 c-446 -371 -862 -773 -1247 -1205 l-138 -155 0 -1078
c0 -947 -2 -1082 -15 -1115 -11 -26 -358 -380 -1184 -1207 l-1169 -1170 -36
-150 c-52 -220 -96 -423 -96 -440 0 -13 167 -15 1474 -15 1003 0 1484 -3 1503
-10 38 -15 3511 -3485 3529 -3527 12 -27 14 -271 14 -1553 0 -1372 -2 -1524
-16 -1553 -9 -18 -875 -892 -1925 -1942 l-1909 -1910 57 -70 c204 -249 466
-550 711 -818 l136 -148 2288 2288 2288 2288 0 1665 0 1665 -2046 2045 c-1125
1125 -2053 2059 -2062 2075 -16 28 -17 244 -22 3089 l-5 3059 -130 -108z"
        />
        <path
          d="M57201 51345 c-608 -834 -1127 -1814 -1486 -2804 -36 -101 -65 -185
-63 -187 2 -2 381 374 841 834 l837 837 -2 745 -3 745 -124 -170z"
        />
        <path
          d="M61456 50814 c-97 -30 -187 -110 -231 -206 -88 -193 8 -419 213 -502
63 -25 180 -27 247 -3 157 54 268 228 251 391 -24 232 -258 388 -480 320z"
        />
        <path
          d="M77312 44937 l-4492 -4492 0 -3804 c0 -3455 1 -3803 16 -3797 60 23
635 386 909 574 l170 117 5 2895 c4 2408 7 2899 19 2920 7 14 1993 2006 4413
4426 l4400 4401 -127 179 c-228 320 -725 971 -809 1061 -9 10 -1030 -1006
-4504 -4480z"
        />
        <path
          d="M78667 43492 l-4327 -4327 2 -2659 3 -2658 190 147 c295 229 676 546
932 774 l63 56 0 1883 c0 1670 2 1887 15 1920 11 27 1157 1178 4065 4087
l4049 4050 -90 150 c-164 271 -542 869 -568 897 -4 4 -1954 -1940 -4334 -4320z"
        />
        <path
          d="M77113 47681 c-65 -24 -97 -46 -152 -106 -168 -182 -104 -475 127
-583 49 -23 70 -27 147 -27 80 0 97 3 155 31 291 139 288 544 -6 676 -70 31
-200 36 -271 9z"
        />
        <path
          d="M55165 46438 c-11 -50 -55 -365 -79 -568 -71 -607 -98 -1251 -77
-1825 14 -370 41 -747 67 -944 l6 -44 1166 1166 c1212 1211 1207 1206 1287
1207 157 1 263 -164 194 -303 -14 -29 -421 -443 -1300 -1322 l-1279 -1280 30
-175 c83 -485 212 -1040 336 -1449 l26 -84 1736 1736 c1364 1364 1747 1740
1782 1756 182 82 361 -104 273 -284 -8 -16 -832 -847 -1830 -1846 l-1816
-1817 63 -173 c125 -346 259 -675 417 -1018 47 -102 92 -199 100 -215 l15 -29
1318 1318 1319 1318 -30 60 c-50 98 -71 196 -71 332 0 143 21 233 81 352 294
585 1132 584 1416 -2 64 -132 79 -196 79 -350 0 -154 -15 -218 -79 -350 -79
-163 -195 -279 -360 -359 -123 -61 -205 -79 -345 -80 -129 -1 -186 10 -314 62
l-88 35 -1364 -1364 -1363 -1363 51 -96 c180 -334 425 -738 656 -1080 129
-192 383 -546 447 -625 l25 -30 1850 1850 1850 1850 0 1375 0 1375 -1653 1653
-1652 1652 -1442 0 -1443 0 -5 -22z"
        />
        <path
          d="M79912 42417 l-3962 -3962 2 -1620 3 -1620 179 180 c168 168 455 476
764 816 l132 147 0 701 c0 674 1 703 19 739 30 57 6607 6627 6653 6647 32 13
117 15 602 15 l565 0 -15 38 c-34 83 -452 915 -592 1177 -138 261 -381 705
-385 705 -1 0 -1785 -1783 -3965 -3963z"
        />
        <path
          d="M70929 45357 c-273 -77 -364 -422 -164 -622 165 -166 447 -135 573
63 122 191 46 443 -162 538 -71 32 -176 41 -247 21z"
        />
        <path
          d="M73639 45357 c-184 -52 -306 -245 -268 -425 51 -249 307 -375 535
-262 178 87 253 315 162 494 -33 65 -112 141 -179 171 -72 32 -180 42 -250 22z"
        />
        <path
          d="M41215 44760 c-2500 -62 -4657 -579 -6439 -1542 -1890 -1021 -3418
-2665 -4353 -4682 -382 -824 -643 -1650 -842 -2666 -77 -394 -159 -989 -200
-1460 -10 -114 -12 -145 -31 -453 -43 -707 -34 -1519 25 -2382 22 -319 56
-588 150 -1205 177 -1158 216 -1466 245 -1950 13 -211 13 -556 0 -779 -53
-911 -338 -1607 -871 -2127 -455 -443 -1013 -715 -1546 -754 -445 -32 -1607
-38 -2123 -10 -1258 67 -2353 215 -3537 480 -1553 347 -3135 910 -4432 1576
-301 155 -626 337 -789 441 -20 13 -13 1 27 -47 441 -535 1185 -1292 1931
-1965 1843 -1660 4169 -3214 6510 -4349 1893 -918 3784 -1604 5825 -2115 1101
-275 2299 -503 3285 -625 2057 -255 4115 -212 6134 130 707 119 1509 299 2126
476 l185 53 -3 382 -2 382 -71 37 c-126 67 -234 199 -280 344 -14 46 -21 93
-21 160 -1 145 37 254 130 373 143 182 404 258 627 183 89 -30 197 -98 245
-153 143 -163 191 -384 126 -578 -51 -149 -152 -267 -288 -336 l-58 -29 0
-320 c0 -200 4 -320 10 -320 18 0 606 198 845 285 244 88 757 289 987 387
l127 54 -2079 2079 -2080 2080 0 290 0 290 2279 -2279 2279 -2279 34 13 c68
28 668 318 792 384 l129 68 -2757 2757 -2756 2756 0 290 0 290 2944 -2944
c2850 -2850 2946 -2944 2970 -2933 100 45 731 420 1001 595 94 60 192 123 218
140 l49 30 -1836 1836 c-1309 1310 -1840 1847 -1851 1873 -13 33 -15 478 -15
4188 0 3780 1 4154 16 4183 9 18 553 570 1210 1227 l1194 1195 -2 4013 -3
4014 -60 24 c-221 91 -963 354 -997 354 -4 0 -8 -1799 -8 -3997 0 -2822 -3
-4010 -11 -4038 -9 -35 -178 -207 -1275 -1305 l-1264 -1265 0 -1310 0 -1310
68 -32 c143 -69 258 -199 304 -346 30 -95 32 -264 4 -347 -83 -248 -303 -410
-556 -410 -307 0 -557 235 -577 541 -15 221 100 439 285 540 l62 34 2 1395 c3
1335 4 1397 21 1430 11 19 583 600 1273 1290 l1254 1255 -2 4000 -3 4000 -228
57 c-249 63 -635 148 -670 148 -16 0 -164 -142 -512 -491 -328 -329 -503 -497
-530 -510 -38 -18 -88 -19 -1257 -19 l-1218 0 0 205 0 205 1153 0 1152 0 350
350 c228 228 344 351 334 354 -23 8 -377 54 -574 76 -579 62 -1240 87 -1910
70z m-775 -1017 l0 -243 -22 0 c-43 1 -109 40 -174 101 l-64 62 0 291 0 291
130 -130 130 -130 0 -242z m-27 -2093 l27 0 0 -205 0 -205 -90 0 c-59 0 -103
5 -130 16 l-40 16 0 291 0 292 103 -103 c80 -79 108 -102 130 -102z m3673 -19
c155 -70 155 -302 0 -372 -39 -18 -108 -19 -1708 -19 l-1668 0 0 205 0 205
1668 0 c1600 0 1669 -1 1708 -19z m-3646 -1516 l0 -290 -130 130 -130 130 0
290 0 290 130 -130 130 -130 0 -290z m1886 -1608 c46 -86 15 -210 -66 -263
-49 -32 -128 -43 -186 -24 -32 10 -166 139 -701 673 l-663 662 0 290 0 290
801 -800 c440 -440 807 -813 815 -828z m1442 1583 c445 -124 690 -600 532
-1032 -16 -43 -45 -106 -66 -140 -82 -135 -244 -271 -380 -320 l-64 -23 0
-913 c0 -642 -3 -927 -11 -960 -11 -45 -70 -105 -1170 -1207 l-1159 -1160 0
-60 0 -60 73 -35 c101 -48 211 -158 261 -260 39 -80 66 -186 66 -260 0 -143
-67 -299 -174 -406 -201 -200 -496 -230 -731 -73 -88 59 -155 136 -201 234
l-34 69 0 177 0 177 42 83 c49 99 144 199 230 244 l58 30 0 1410 0 1410 -165
165 -165 165 0 290 0 290 351 -350 c230 -230 358 -364 370 -390 18 -38 19 -86
19 -1147 0 -610 3 -1108 8 -1108 4 0 436 429 960 953 l952 952 -2 864 -3 863
-75 28 c-216 79 -387 248 -466 460 -177 472 121 980 621 1061 77 12 241 2 323
-21z m-3328 -2185 l0 -290 -130 130 -130 130 0 290 0 290 130 -130 130 -130 0
-290z m0 -7500 l0 -290 -130 130 -130 130 0 290 0 290 130 -130 130 -130 0
-290z m1193 -902 c584 -582 914 -917 923 -938 18 -43 18 -126 0 -168 -16 -38
-59 -83 -101 -105 -41 -21 -131 -20 -175 2 -19 10 -380 363 -802 784 l-768
767 0 289 c0 159 3 286 8 282 4 -4 416 -415 915 -913z m-1193 -808 l0 -290
-130 130 -130 130 0 290 0 290 130 -130 130 -130 0 -290z m1861 -1484 c53 19
84 23 179 23 98 0 125 -4 182 -26 247 -93 392 -297 392 -548 0 -204 -96 -380
-267 -491 -84 -55 -166 -80 -277 -86 -119 -7 -188 7 -291 59 -146 73 -241 183
-294 343 -25 73 -27 90 -23 195 4 83 11 129 25 166 l20 52 -618 618 -619 619
0 290 0 290 763 -763 763 -763 65 22z m-1861 -836 l0 -290 -130 130 -130 130
0 290 0 290 130 -130 130 -130 0 -290z m0 -2000 l0 -290 -130 130 -130 130 0
290 0 290 130 -130 130 -130 0 -290z m531 -3555 c329 -110 540 -401 540 -745
0 -418 -307 -748 -733 -790 l-68 -7 0 210 0 209 63 5 c120 10 230 88 294 209
26 49 28 63 28 159 0 99 -2 110 -33 172 -56 115 -165 191 -290 204 l-62 7 0
205 0 205 84 -6 c55 -4 118 -17 177 -37z m-562 -541 c-80 -125 -79 -286 1
-412 l30 -48 0 -239 c0 -132 -3 -240 -6 -240 -18 0 -147 76 -196 116 l-58 46
0 571 0 572 57 45 c32 25 89 62 128 82 l70 37 3 -241 2 -241 -31 -48z"
        />
        <path
          d="M43475 39696 c-116 -29 -206 -103 -258 -214 -27 -58 -31 -78 -32
-152 0 -80 3 -92 38 -162 142 -289 532 -289 674 0 35 70 38 82 38 162 -1 74
-5 94 -32 152 -53 114 -150 191 -271 217 -65 13 -92 13 -157 -3z"
        />
        <path
          d="M80658 40823 l-3208 -3208 0 -400 0 -400 272 270 c275 272 501 477
703 638 615 489 1172 757 1770 852 55 9 192 19 305 22 l205 5 735 733 c712
710 737 734 789 749 49 14 268 16 2178 16 1168 0 2123 3 2123 6 0 16 -181 598
-271 872 l-100 302 -1141 -2 -1140 -3 -23 -62 c-82 -228 -299 -423 -545 -489
-101 -27 -302 -26 -403 4 -352 101 -587 408 -587 766 0 269 130 512 353 665
192 131 464 168 687 92 227 -77 401 -241 492 -462 l32 -79 1063 0 1062 0 -40
113 c-208 581 -548 1426 -822 2037 l-74 165 -604 3 -604 2 -3207 -3207z"
        />
        <path
          d="M47020 39643 c0 -3880 -1 -3989 -19 -4028 -13 -28 -388 -408 -1210
-1230 l-1191 -1190 0 -4015 0 -4015 1818 -1818 c999 -999 1820 -1817 1824
-1817 10 0 220 151 440 316 323 244 635 499 960 786 l148 131 2 3821 c3 3693
4 3822 21 3856 11 19 244 260 519 536 l500 501 -20 39 c-11 21 -32 77 -48 124
-25 77 -28 98 -28 230 0 138 1 149 32 240 42 122 97 214 180 301 268 285 711
330 1026 105 77 -55 181 -165 225 -239 83 -141 116 -276 108 -447 -15 -341
-232 -617 -567 -722 -64 -20 -96 -23 -220 -23 -157 0 -234 16 -344 72 l-49 25
-459 -459 -458 -458 0 -3550 0 -3549 76 74 c86 85 388 407 516 550 410 459
849 1035 1181 1549 1228 1898 1916 4040 2081 6476 54 786 46 1670 -19 2315
-91 894 -297 1805 -598 2643 l-60 169 -138 -138 -139 -139 0 -2683 0 -2684 23
-6 c12 -3 67 -28 122 -56 86 -43 113 -63 195 -145 107 -108 149 -173 191 -295
61 -176 61 -359 -1 -527 -36 -100 -68 -155 -136 -239 -125 -154 -304 -251
-514 -280 -153 -21 -310 8 -463 87 -75 38 -110 65 -188 143 -82 81 -103 109
-142 190 -66 132 -89 228 -89 365 0 137 23 233 88 365 39 79 62 109 138 186
95 95 177 149 291 190 l60 22 5 2753 c5 2662 6 2755 24 2789 10 19 128 145
261 280 l244 245 -26 60 c-188 443 -486 1020 -756 1463 l-111 182 -448 -447
-448 -448 0 -2224 c0 -1652 -3 -2234 -12 -2265 -10 -36 -193 -223 -1460 -1491
l-1448 -1450 0 -2581 0 -2581 68 -33 c97 -48 208 -161 255 -260 43 -91 57
-156 57 -262 0 -288 -206 -525 -495 -570 -216 -34 -447 70 -570 255 -77 117
-110 279 -85 426 27 160 144 323 293 405 l67 38 0 2654 c0 2605 0 2655 19
2692 11 21 639 656 1455 1472 l1436 1435 0 2221 c0 1922 2 2227 15 2270 13 44
57 91 540 574 l525 525 -103 146 c-395 555 -798 1031 -1297 1529 -707 708
-1420 1268 -2320 1822 l-75 47 -5 -4092 c-5 -3814 -6 -4094 -22 -4122 -9 -16
-544 -556 -1187 -1200 l-1171 -1170 0 -3045 1 -3045 77 -37 c134 -64 244 -191
293 -340 19 -59 24 -93 23 -178 0 -113 -13 -168 -61 -266 -40 -84 -168 -210
-255 -252 -128 -62 -267 -77 -402 -42 -141 36 -249 109 -331 225 -68 95 -97
179 -103 304 -6 124 6 188 55 291 43 89 146 199 236 250 l57 32 0 3114 c0
2778 2 3119 15 3152 11 26 358 380 1190 1212 l1175 1175 0 4135 0 4136 -232
121 c-195 102 -609 303 -624 303 -2 0 -4 -1794 -4 -3987z m2895 1319 c137 -45
237 -105 329 -198 290 -291 313 -735 55 -1060 -78 -98 -205 -191 -318 -234
l-61 -22 0 -2717 0 -2716 -24 -50 c-19 -40 -288 -314 -1410 -1435 l-1386
-1385 0 -1825 0 -1825 62 -30 c80 -38 182 -134 231 -216 57 -97 78 -176 78
-294 0 -177 -47 -291 -171 -415 -114 -114 -246 -170 -405 -170 -159 0 -292 56
-406 169 -121 121 -173 244 -173 411 0 167 52 290 173 411 53 53 95 85 138
105 l63 29 0 1895 c0 1832 1 1896 19 1935 13 28 445 466 1405 1425 l1386 1385
0 2651 0 2650 -57 18 c-262 82 -471 313 -528 584 -17 80 -19 235 -4 318 54
291 282 534 579 614 101 27 332 23 425 -8z"
        />
        <path
          d="M49583 40566 c-104 -34 -195 -114 -241 -214 -23 -48 -27 -71 -27
-147 0 -77 4 -99 27 -148 38 -80 114 -158 191 -193 54 -26 73 -29 157 -29 85
0 101 3 155 29 33 17 80 50 105 76 26 25 59 72 76 105 26 54 29 70 29 160 0
89 -3 106 -28 157 -63 128 -186 209 -326 215 -46 2 -93 -3 -118 -11z"
        />
        <path
          d="M59498 42311 c-76 -25 -119 -53 -172 -112 -90 -100 -116 -254 -66
-384 32 -82 122 -173 205 -205 90 -36 208 -34 291 4 77 35 154 112 191 191 24
52 28 72 28 150 0 78 -4 98 -29 152 -35 76 -113 154 -191 189 -75 35 -180 41
-257 15z"
        />
        <path
          d="M83040 41860 c-73 -16 -146 -57 -199 -115 -163 -180 -115 -459 101
-576 60 -33 67 -34 168 -34 96 0 110 3 164 29 33 16 79 48 101 71 23 22 55 68
71 101 26 54 29 68 29 164 0 100 -1 108 -34 168 -19 34 -52 79 -74 98 -84 77
-221 116 -327 94z"
        />
        <path
          d="M81801 39096 l-573 -573 48 -12 c246 -60 569 -199 784 -338 195 -127
307 -228 532 -483 744 -843 1430 -1756 1998 -2660 57 -91 107 -169 112 -175 5
-5 161 143 386 367 207 207 390 382 405 387 19 8 344 11 1006 11 l978 0 -4 28
c-48 381 -164 1110 -249 1565 l-48 257 -1067 0 -1066 0 -18 -47 c-82 -225
-281 -408 -525 -485 -64 -20 -96 -23 -220 -23 -124 0 -156 3 -220 23 -275 86
-479 298 -551 573 -33 123 -31 282 5 402 46 154 115 267 229 374 258 241 646
281 950 96 153 -93 286 -260 341 -430 l18 -53 1018 0 c811 0 1019 3 1015 13
-2 6 -25 109 -50 227 -88 403 -215 920 -357 1448 l-22 82 -2141 0 -2140 0
-574 -574z"
        />
        <path
          d="M84161 38054 c-98 -35 -175 -106 -219 -203 -22 -47 -27 -70 -27 -146
0 -81 3 -97 32 -157 135 -284 532 -285 670 0 24 50 27 69 28 152 0 84 -3 102
-29 157 -34 74 -113 154 -183 185 -64 29 -209 35 -272 12z"
        />
        <path
          d="M85299 34833 l-366 -368 103 -177 c622 -1072 1194 -2337 1606 -3548
313 -923 575 -1966 686 -2738 l28 -193 32 168 c235 1242 357 2930 323 4477
-15 694 -37 1134 -87 1756 -22 278 -73 810 -90 943 l-7 47 -931 0 -931 0 -366
-367z"
        />
        <path
          d="M51420 32231 c-101 -33 -189 -108 -237 -201 -25 -50 -28 -65 -28
-160 0 -95 3 -111 28 -162 34 -69 102 -140 166 -172 315 -160 655 165 512 489
-28 63 -110 146 -178 180 -49 24 -73 29 -148 32 -49 1 -101 -1 -115 -6z"
        />
        <path
          d="M52799 30897 c-104 -30 -199 -112 -247 -215 -23 -48 -27 -71 -27
-147 0 -82 3 -97 32 -156 83 -167 268 -254 438 -204 248 72 352 356 209 570
-85 127 -260 193 -405 152z"
        />
      </g>
    </svg>
  );
};

export default ArtifactLogo;
